var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9459 8.33341C12.9459 9.94425 11.6401 11.2501 10.0292 11.2501C8.41842 11.2501 7.11255 9.94425 7.11255 8.33341C7.11255 6.72258 8.41842 5.41675 10.0292 5.41675C11.6401 5.41675 12.9459 6.72258 12.9459 8.33341Z",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 1.66675C6.31802 1.66675 3.33325 4.68161 3.33325 8.40066C3.33325 10.5272 4.16659 12.1807 5.83325 13.6576C7.00801 14.6986 9.14542 16.9317 9.99992 18.3333C10.8977 16.9596 12.9918 14.6986 14.1666 13.6576C15.8333 12.1807 16.6666 10.5272 16.6666 8.40066C16.6666 4.68161 13.6818 1.66675 9.99992 1.66675Z",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.c8eff31f34af8c4b3943ee06f15aa29b.svg";
export { ForwardRef as ReactComponent };